import type {
  FieldTeamMember,
  FieldTeamRole,
} from "../redux/Auth/auth.slice";
import { readJwtToken } from "./decode-jwt";

/** Profile from Cognito Id token (native bridge / Amplify JWT). */
export function fieldTeamMemberFromIdToken(
  idToken: string,
  fallbackEmail: string
): FieldTeamMember | null {
  const payload = readJwtToken(idToken) as {
    sub?: string;
    email?: string;
    "cognito:groups"?: string[];
    "custom:first_name"?: string;
    "custom:last_name"?: string;
  };
  if (!payload?.sub && !payload?.email && !fallbackEmail) {
    return null;
  }
  const userID = String(payload.sub ?? "");
  const firstName = String(payload["custom:first_name"] ?? "");
  const lastName = String(payload["custom:last_name"] ?? "");
  const email =
    (typeof payload.email === "string" ? payload.email : null) ??
    fallbackEmail;
  const groups = payload["cognito:groups"];
  const role: FieldTeamRole = groups?.includes("MedicalGroup-Administrator")
    ? "admin"
    : "field_technician";
  const name =
    lastName || firstName
      ? `${lastName}, ${firstName}`
      : email.split("@")[0] || email;
  if (!email) {
    return null;
  }
  return {
    id: userID || email,
    name,
    email,
    role,
    firstName: firstName.trim() || undefined,
    lastName: lastName.trim() || undefined,
  };
}
